export default "__VITE_PUBLIC_ASSET__63c105a5__"